import get from 'transmute/get';
export function getIsChannelInstanceFailedById({
  channelInstances
}, {
  channelInstanceId
}) {
  if (!channelInstanceId) return false;
  const failedInstanceIds = get('failedInstanceIds', channelInstances);
  return failedInstanceIds.contains(channelInstanceId);
}